import { useContext } from 'react';
import { GlobalContext } from '../context/GlobalState';

export default function Transaction({ transaction }) {
    const { deleteTransaction } = useContext(GlobalContext);
    const sign = transaction.amount > 0 ? '+' : '-';

    return (
        <li className={transaction.amount > 0 ? "plus" : 'minus'}>
            <p>
                {transaction.text}
                <span className={`amount ${transaction.amount > 0 ? 'grn-clr' : 'red-clr'}`}>{sign}${Math.abs(transaction.amount)}</span>
            </p>
            <p className='small-text'>
                {transaction.website}
                <span>{transaction.time}</span>
                <span className='delete-btn' onClick={() => deleteTransaction(transaction.id)}>x</span>
            </p>
        </li >
    )
}